const projects = [
  {
    title: "Sinfoni",
    image: "/img/sinfoni/mockup-large.png",
    tags: ["UX UI", "Branding", "Motion"],
    description:
      "Direction artistique et webdesign pour Sinfoni, cabinet de conseil en assurance et investissement. J'ai accompagné Sinfoni dans la refonte complète de son site web, de la direction artistique à la mise en page sous Figma. Mon objectif : refléter leur expertise et leur sérieux à travers une interface claire, élégante et accessible. J'ai également assuré la cohérence graphique sur les supports de communication associés.",
    images: [
      "/img/sinfoni/mockup-large.png",
      "/img/sinfoni/mockup-sinfoni.jpg",
      "/img/sinfoni/layoutSinfoni.jpg",
      "/img/sinfoni/sinfoniDesign.jpg",
      "/img/sinfoni/backSinfoni.jpg",
      "/img/sinfoni/sinfoniGridfull.png",
    ],
    designConcepts: [
      {
        icon: "/img/sinfoni/eco-responsable.svg",
        alt: "éco-responsable",
        text: "Un design présentant la vision éco-responsable de Sinfoni",
      },
      {
        icon: "/img/sinfoni/modulable.svg",
        alt: "modulable",
        text: "Un design modulable permettant une maintenance facile",
      },
      {
        icon: "/img/sinfoni/transparence.svg",
        alt: "transparence",
        text: "Un jeu sur la transparence pour mettre en avant le contenu",
      },
    ],

    link: "https://monprojet1.com",
  },
  {
    title: "Green Data",
    image: "/img/greenData/webdesign-thegreendata.png",
    tags: ["Branding", "Illustration", "Motion", "Lottie"],
    description:
      "Identité visuelle et motion design pour The Green Data, acteur tech au service de l’agriculture. J’ai créé l’univers graphique du projet, de l’illustration des assets jusqu’à l’animation de micro-interactions au format Lottie. J’ai également réalisé le montage d’une vidéo de présentation utilisée sur les salons professionnels, avec pour objectif de capter l’attention et valoriser les solutions innovantes proposées par l’entreprise.",
    images: [
      "/img/greenData/webdesign-thegreendata.png",
      "/img/greenData/analyse-exploitation.svg",
      "/img/greenData/screenData.svg",
      "/img/greenData/maia.png",
      "/img/greenData/screenData.jpg",
    ],
    animations: [{ name: "greenData" }],
    designConcepts: [
      {
        text: "Création d’illustrations 2D pour représenter les différents secteurs d’intervention de l’entreprise.",
      },
      {
        text: "Réalisation de supports imprimés, notamment des affiches pour des événements comme le Salon de l’Agriculture.",
      },
      {
        text: "Production d’un motion design explicatif pour vulgariser les objectifs de l’entreprise de manière simple et accessible.",
      },
    ],
    videos: [
      {
        src: "/img/greenData/presentation-greendata.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://monprojet2.com",
  },

  {
    title: "Opera",
    image: "/img/opera/mockup-carte-de-visite.jpg",
    tags: ["Branding"],
    description:
      "Direction artistique et création d’identité visuelle pour Opéra, experte en expérience retraite. En tant que directeur artistique freelance, j’ai conçu l’identité complète de la marque Opéra, filiale de Sinfoni. De la création du logo à son animation, en passant par le choix des codes graphiques et colorimétriques, j’ai construit un univers visuel clair, élégant et adapté aux standards actuels de la communication institutionnelle.",
    images: [
      "/img/opera/process-logo-opera.svg",
      "/img/opera/logo-opera-gris.svg",
      "/img/opera/logo-opera.svg",
      "/img/opera/mockup-carte-de-visite.jpg",
      "/img/opera/code-couleurs-opera.svg",
      "/img/opera/logo-opera-bicolore.svg",
    ],
    animations: [{ name: "opera" }],
    designConcepts: [
      {
        text: "Création de l'identité visuelle de la société Opera en tant que Directeur Artistique freelance.",
      },
      {
        text: "Conception d’un logo identifiable et moderne, répondant aux attentes en matière de clarté et de codes actuels de communication.",
      },
      {
        text: "Animation du logo pour enrichir l’univers de marque et renforcer son impact visuel.",
      },
    ],
    videos: [
      {
        src: "/img/opera/animation-logo-opera.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://monprojet2.com",
  },
  {
    title: "Euroconstruct",
    image: "/img/euroconstruct/mockup-euroconstruct.png",
    tags: ["Branding", "UX UI"],
    description:
      " Refonte de l’identité visuelle et du site d’Euroconstruct, réseau européen d’experts du bâtiment. J’ai repensé l’image de marque et l’interface web d’Euroconstruct, une organisation présente dans 19 pays d’Europe, spécialisée dans la recherche et le conseil pour le secteur de la construction. L’objectif : moderniser l’expérience utilisateur tout en respectant le positionnement institutionnel du réseau.",
    images: [
      "/img/euroconstruct/mockup-euroconstruct.png",
      "/img/euroconstruct/bandeau-euroconstruct.jpg",
      "/img/euroconstruct/webdesign-euroconstruct.jpg",
      "/img/euroconstruct/webdesign-euroconstruct.png",
    ],
    animations: [{ name: "euroconstruct" }],
    link: "https://monprojet2.com",
  },
  {
    title: "Mobitype",
    image: "/img/mobitype/mobitype.jpg",
    tags: ["Branding", "UX UI", "Motion"],
    description:
      "Identité visuelle, UX/UI et motion design pour Mobitype, plateforme d’analyse de données mobilité. J’ai conçu l’univers graphique complet du site vitrine et de la plateforme Mobitype, en travaillant l’ergonomie, la clarté des interfaces et l’impact visuel. Pour dynamiser la navigation et enrichir l’expérience utilisateur, j’ai réalisé des animations sur After Effects, intégrées au format Lottie.",
    images: [
      "/img/mobitype/mobitype.jpg",
      "/img/mobitype/mobitypeDashboard.png",
    ],
    animations: [
      { name: "mobitype1" },
      { name: "mobitype" },
      { name: "mobitype2" },
      // { name: "mobitype3" },
      // { name: "mobitype4" },
      // { name: "mobitype5" },
      { name: "mobitype6" },
      { name: "mobitype7" },
      { name: "mobitype8" },
      // { name: "mobitype9" },
      { name: "mobitype10" },
      // { name: "mobitype11" },
      { name: "mobitype12" },
      { name: "mobitype13" },
      { name: "mobitype14" },
      { name: "mobitype15" },
      // { name: "mobitype16" },
      { name: "mobitype17" },
      { name: "mobitype18" },
    ],
    link: "https://monprojet2.com",
  },
  {
    title: "FDTI",
    image: "/img/fdti/fdti-cover.png",
    tags: ["Motion", "Lottie"],
    description:
      " Illustration, motion design et animation 3D pour FDTI, solution SaaS multi-sectorielle. J’ai été en charge de la création d’illustrations sur-mesure pour représenter les univers de la finance, du marketing, des RH et des opérations. Ces visuels ont ensuite été animés sous After Effects puis optimisés pour le web via Lottie.js. J’ai également réalisé des animations 3D de personas pour renforcer l’accessibilité et l’impact visuel de l’outil.",
    // images: [
    //   "/img/euroconstruct/mockup-euroconstruct.png",
    //   "/img/euroconstruct/bandeau-euroconstruct.jpg",
    //   "/img/euroconstruct/webdesign-euroconstruct.jpg",
    //   "/img/euroconstruct/webdesign-euroconstruct.png",
    // ],
    videos: [
      {
        src: "https://player.vimeo.com/video/453601203",
        type: "vimeo",
      },
      { src: "https://player.vimeo.com/video/942536694", type: "vimeo" },
      { src: "https://player.vimeo.com/video/942536704", type: "vimeo" },
    ],

    animations: [
      {
        name: "finnance",
      },
      { name: "marketing" },
      { name: "operationnel" },
      { name: "rh" },
    ],
    link: "https://monprojet2.com",
  },
  {
    title: "Star miners",
    image: "/img/starminers/starminer.png",
    tags: ["Motion", "Lottie", "Branding"],
    description:
      " Direction artistique, motion design et création NFT pour Star Miners, jeu Web3 sur Solana. En tant que directeur artistique du projet, j’ai défini l’univers visuel de Star Miners et supervisé la création de sa première collection NFT. J’ai également réalisé des teasers animés pour les réseaux sociaux, ainsi que des animations web au format Lottie, intégrées directement dans le site du jeu pour enrichir l’expérience utilisateur.",
    // images: [
    //   "/img/euroconstruct/mockup-euroconstruct.png",
    //   "/img/euroconstruct/bandeau-euroconstruct.jpg",
    //   "/img/euroconstruct/webdesign-euroconstruct.jpg",
    //   "/img/euroconstruct/webdesign-euroconstruct.png",
    // ],
    videos: [
      {
        src: "https://player.vimeo.com/video/942538843",
        type: "vimeo",
      },
      { src: "https://player.vimeo.com/video/942539347", type: "vimeo" },
      { src: "https://player.vimeo.com/video/942538737", type: "vimeo" },
      { src: "https://player.vimeo.com/video/942538728", type: "vimeo" },
      { src: "https://player.vimeo.com/video/942538693", type: "vimeo" },
      { src: "https://player.vimeo.com/video/942538719", type: "vimeo" },
    ],

    animations: [
      {
        name: "starminers",
      },
    ],
    link: "https://monprojet2.com",
  },
  {
    title: "Habitat & Jardin",
    image: "/img/hetj/renderTable.png",
    tags: ["Motion", "Lottie"],
    description:
      " Motion design, visuels 3D et communication digitale pour Habitat & Jardin (Gecodis). Au sein de Gecodis, j’ai contribué à la stratégie visuelle du site e-commerce Habitat & Jardin. J’ai réalisé des rendus 3D de produits, conçu des bannières animées et des pages événementielles, et assuré le traitement photo pour renforcer l’impact visuel de la marque. J’ai également produit des animations au format Lottie pour dynamiser l’expérience utilisateur sur le site.",
    images: [
      "/img/hetj/renderTable.png",
      "/img/hetj/img5.jpg",
      "/img/hetj/img8.jpg",
      "/img/hetj/imgchambre.png",
      "/img/hetj/tranchePiscine.jpg",
    ],
    canvasSequence: {
      folder: "hetjImg", // ← nom du dossier dans /public/assets/<folder>/images/
      frameCount: 165, // ← nombre d’images dans la séquence
    },
    link: "https://monprojet2.com",
  },
  {
    title: "EDS",
    image: "/img/EDS/template-eds.jpg",
    tags: ["Branding", "Motion"],
    description:
      "Identité visuelle et motion design pour EDS, organisme de formation du MEDEF. J’ai conçu l’identité graphique et les supports animés de l’Entreprise du Droit Social (EDS), une association agréée par le ministère du Travail. L’objectif : moderniser l’image de l’organisme et accompagner sa mission de formation de plus de 3 500 conseillers prud’hommes employeurs, répartis dans 271 conseils à travers la France.",
    videos: [
      {
        src: "/img/EDS/logoEDS.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    images: [
      "/img/EDS/recherche-eds.jpg",
      "/img/EDS/eds-process.svg",
      "/img/EDS/grid-eds.jpg",
      "/img/EDS/doc2.jpg",
      "/img/EDS/carte-visite-eds.png",
      "/img/EDS/template-eds.jpg",
    ],

    link: "https://monprojet2.com",
  },
  {
    title: "Crypto tech",
    image: "/img/crypto/cryptomockup.jpg",
    tags: ["UX UI", "Motion"],
    description:
      "UX/UI design et motion 3D pour Crypto Tech Solutions. J’ai conçu le webdesign complet du site de Crypto Tech Solutions, en veillant à allier lisibilité, modernité et impact visuel. Pour enrichir l’expérience utilisateur, j’ai également réalisé des animations en motion design 3D intégrées au site, afin de valoriser les services tech et l’univers Web3 de l’entreprise.",
    images: [
      "/img/crypto/cryptomockup.jpg",
      "/img/crypto/screen-2.png",
      "/img/crypto/homeLanding.png",
    ],

    link: "https://monprojet2.com",
  },

  {
    title: "Storyfox",
    image: "/img/storyfox/mockupLaptop.jpg",
    tags: ["Branding", "Motion", "Lottie"],
    description:
      "Branding et motion design pour Storyfox, solution de création vidéo automatisée. J’ai participé à la conception de l’univers graphique de Storyfox, une application innovante qui permet aux entreprises de produire facilement des vidéos personnalisées grâce à des templates automatisés. Mon rôle a consisté à créer des éléments animés en motion design, en cohérence avec l’identité de marque, pour renforcer l’attractivité et l’efficacité de l’outil.",
    images: ["/img/storyfox/mockupLaptop.jpg"],
    videos: [
      {
        src: "/img/storyfox/storyfoxReel.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/storyfox/BAB1.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/storyfox/BAB2.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/storyfox/BAB3.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/storyfox/BAB4.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],
    animations: [
      {
        name: "fox",
      },
    ],
    // customView: "LottieColorView",
    link: "https://monprojet2.com",
  },
  {
    title: "Eglise VR",
    image: "/img/eglise/larchant-mockup.jpg",
    tags: ["Motion", "web VR"],
    description:
      " Direction artistique et création d’une expérience WebVR immersive au cœur du XIIe siècle. En collaboration avec l’association culturelle de Larchant et la région Seine-et-Marne, j’ai conçu une reconstitution virtuelle de l’église de Larchant telle qu’elle existait au XIIe siècle. Ce projet mêle modélisation 3D, motion design et technologies WebVR pour offrir aux visiteurs une immersion historique unique, accessible depuis un simple navigateur.",
    images: [
      "/img/eglise/larchant-mockup.jpg",
      "/img/eglise/foule.png",
      "/img/eglise/gravure08.jpg",
      "/img/eglise/eglise-IA-1.jpg",
      "/img/eglise/gravure05.jpg",
      "/img/eglise/wide-angle-church.jpg",
      "/img/eglise/topview.png",
      "/img/eglise/4.jpg",
      "/img/eglise/3Dchurch.png",
      "/img/eglise/wide-angle-church.jpg",
    ],
    videos: [
      {
        src: "/img/eglise/timelapseChurch.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],
    canvasSequence: {
      folder: "egliseVr", // ← nom du dossier dans /public/assets/<folder>/images/
      frameCount: 31, // ← nombre d’images dans la séquence
    },
    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "Spring",
    image: "/img/spring/thumbnail.png",
    tags: ["Motion", "Illustration"],
    description:
      " Projet personnel – storytelling animé autour de la routine matinale. Spring est une création personnelle mêlant illustration et motion design pour capturer la poésie du lever du jour. J’ai imaginé une série de scènes fluides et harmonieuses, comme un générique d’introduction d’une série ou d’un film d’animation. L’objectif : proposer un voyage visuel doux et inspirant, en travaillant la narration, le rythme et l’unité graphique.",
    images: [
      "/img/spring/gif1.gif",
      "/img/spring/gif2.gif",
      "/img/spring/gif3.gif",
    ],
    videos: [
      {
        src: "/img/spring/montageLight.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "Star",
    image: "/img/personalBranding/thumbnail.png",
    tags: ["Motion", "Illustration"],
    description:
      " Motion design personnel pour mon branding de créatif freelance. Star est un projet de motion design abstrait, conçu pour présenter mon univers visuel et mon offre en tant que créatif indépendant. J’y explore une ambiance graphique sombre, ponctuée de touches de vert et d’un style tech minimaliste. Pensé comme une capsule de communication, ce motion met en avant mon approche du storytelling visuel et invite à entrer dans mon univers.",
    images: [
      "/img/personalBranding/storyboard.jpg",
      "/img/personalBranding/gif1.gif",
      "/img/personalBranding/BTS1light.gif",
      "/img/personalBranding/bts2light.gif",
      "/img/personalBranding/gif2light.gif",
      "/img/personalBranding/gif3light.gif",
    ],
    videos: [
      {
        src: "/img/personalBranding/finallight.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "Luno",
    image: "/img/luno/cover-luno.png",
    tags: ["Motion", "Branding"],
    description:
      "Motion design 3D pour Luno, startup Web3 en accompagnement de projets crypto. J’ai conçu un teaser en motion design pour renforcer l’identité de marque de Luno, une jeune startup spécialisée dans le conseil et les services autour des projets blockchain. Ce contenu animé mêle 3D et narration visuelle pour exprimer la vision et la philosophie de l’entreprise, en posant les bases d’un univers graphique à la fois technologique et engageant.",
    images: ["/img/luno/lunostoryboard.png"],
    videos: [
      {
        src: "/img/luno/LUNO.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "DATAHUNTER",
    image: "/img/datahunter/plaine-loop.gif",
    tags: ["Motion"],
    description:
      "Direction artistique, création d’assets 3D et motion design pour DATAHUNTER, jeu Web3 sur Solana. En tant que directeur artistique du projet Datahunter, j’ai supervisé l’uniformité visuelle du jeu : interface, personnages (NPC), environnement et communication. J’ai produit des assets 2D/3D, des animations, des sprites, des visuels promotionnels et des contenus motion design, en combinant design, illustration et outils tels qu’After Effects, Blender, Figma ou encore l’IA générative. L’objectif : bâtir un univers cohérent, immersif et engageant pour la communauté Web3.",
    images: [
      "/img/datahunter/black&white.gif",
      "/img/datahunter/login.gif",
      "/img/datahunter/plaine-loop.gif",
    ],

    videos: [
      {
        src: "/img/datahunter/Comp4.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/datahunter/3Dtrailer.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/datahunter/banner.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/datahunter/Comp 1_1.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/datahunter/night-plaine.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/datahunter/night-sand.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/datahunter/scene-masterxport.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "oxygen",
    image: "/img/oxygen/cover-oxygen.png",
    tags: ["Motion", "Branding"],
    description:
      " Motion design explicatif pour Oxygen, projet fictif autour de l'identité numérique. J’ai réalisé un motion design court et percutant pour illustrer l’offre d’Oxygen, une solution Web3 axée sur le tracking d'identification. Ce projet fictif visait à poser les bases visuelles d’une communication claire et dynamique, pensée pour les réseaux sociaux. L’animation met en scène les concepts-clés de la tech blockchain dans un style épuré et accessible.",

    videos: [
      {
        src: "/img/oxygen/OXYGENlight.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },

  {
    title: "Vertuoza",
    image: "/img/vertuoza/cover.png",
    tags: ["Motion"],
    description:
      "Animation d’intro pour la chaîne YouTube de Vertuoza, plateforme de formation BTP. J’ai conçu et animé le jingle d’ouverture des vidéos YouTube de Vertuoza, une entreprise spécialisée dans la formation en ligne pour les professionnels du bâtiment. Cette intro motion design 2D pose un ton dynamique et professionnel, tout en renforçant l’identité visuelle de la marque sur ses supports vidéo.",

    videos: [
      {
        src: "/img/vertuoza/logoVertuoza.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },

  {
    title: "Lepage Studio",
    image: "/img/lepagestudio/cover.png",
    tags: ["Motion"],
    description:
      "Vidéo d’intro en motion design pour Lepage Studio, mon activité de freelance. ’ai conçu ce motion design comme une capsule d’introduction destinée à présenter mon univers créatif et mon approche du métier. Utilisée dans le cadre de ma communication freelance, cette vidéo s’adresse aux agences, studios et clients potentiels en mettant en avant mon expertise en motion 2D/3D et mon accompagnement sur mesure, du concept à la production.",

    videos: [
      {
        src: "/img/lepagestudio/lepagestudio.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },

  {
    title: "Tennis",
    image: "/img/tennis/cover.png",
    tags: ["Motion"],
    description:
      "Exploration personnelle – jingle animé autour de l’univers du tennis. Inspiré par un match de Roland-Garros, j’ai imaginé ce motion design comme une intro dynamique autour du tennis. Ce projet mêle animation 3D sous Blender et éléments graphiques 2D pour créer un jingle percutant, entre énergie sportive et direction artistique stylisée. Une expérimentation personnelle pour explorer rythme, mise en scène et storytelling visuel.",

    videos: [
      {
        src: "/img/tennis/rendertennis.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "Crypto Sphere",
    image: "/img/crytposphere/cryptosphere.png",
    tags: ["Motion"],
    description:
      "Motion design 3D pour Crypto Sphere, projet blockchain autour du tracking de données. J’ai réalisé un motion design en 3D pour illustrer l’univers de Crypto Sphere, un projet crypto axé sur le suivi de données on-chain. Pensée comme une animation de fond ou un support de communication, cette création visuelle apporte une dimension tech et immersive à l’identité du projet, tout en restant légère et adaptable pour le web.",

    videos: [
      {
        src: "/img/crytposphere/cryptosphere.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "Happy New Year",
    image: "/img/happy/cover.png",
    tags: ["Motion", "Illustration"],
    description:
      "Carte de vœux animée – exploration personnelle en motion design 2D. J’ai imaginé et animé une carte de vœux originale dans le cadre d’un projet personnel, où un personnage traverse un portail symbolique pour célébrer la nouvelle année. Réalisée sous After Effects, cette animation met l’accent sur l’illustration et la narration visuelle, dans un style graphique à la fois festif et poétique.",

    videos: [
      {
        src: "/img/happy/happy.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "Clip RJ-ONE",
    image: "/img/clip/cover.png",
    tags: ["Motion"],
    description:
      "Clip animé en 3D pour RJ-ONE – projet de fin d’études. Réalisé en 2016, ce clip animé pour le rappeur RJ-ONE marque l’un de mes premiers projets d’envergure en 3D. Entièrement produit sous Cinema 4D, il mêle storytelling visuel et esthétique urbaine dans un univers animé sur-mesure. Bien qu’il s’agisse de mes débuts dans la 3D, ce projet reste une étape fondatrice de mon parcours créatif. ",

    videos: [
      {
        src: "/img/clip/fullclip.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "motion BNIC",
    image: "/img/bnic/cover.png",
    tags: ["Motion"],
    description:
      "Motion design explicatif pour le BNIC, réalisé au sein de BIP Advisory (groupe BDO). En tant que directeur artistique junior, j’ai conçu un motion design pédagogique destiné à présenter une plateforme d’analyse liée aux BNIC. L’objectif : expliquer son fonctionnement et son usage quotidien de manière claire et accessible. Ce projet a été réalisé dans le cadre de ma mission au sein du cabinet de conseil BIP Advisory. ",

    videos: [
      {
        src: "/img/bnic/video.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "Enseignement motion design",
    image: "/img/cours/cover.png",
    tags: ["Motion"],
    description:
      "Accompganment d'étudiants dans leur formation et apprentisage du motion design 2D 3D. également professeurEnseignement du motion design 2D/3D – accompagnement pédagogique et direction de filière. Depuis 2018, j’enseigne le motion design dans plusieurs écoles reconnues, dont L’École Multimédia et les Gobelins. J’accompagne les étudiants dans leur apprentissage du motion design 2D et 3D, de l’initiation aux projets avancés, tout en étant professeur référent de la filière Motion Design. Voici un aperçu de projets réalisés en cours ou à titre démonstratif, illustrant mon approche créative et pédagogique. réferrent de la filiere motion design",

    videos: [
      {
        src: "/img/cours/intropres.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/cours/benjerry.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/cours/run.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/cours/run_1.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/cours/batblur.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/cours/dude.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/cours/fooh.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/cours/vfx.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "habillage motion",
    image: "/img/habillage/cover.png",
    tags: ["Motion"],
    description:
      "Création d’un template animé pour Fast Good Cuisine, habillage motion 2D/3D. J’ai conçu un asset graphique animé sous After Effects pour afficher les scores dans les vidéos de la chaîne YouTube Fast Good Cuisine. Ce template dynamique est facilement réutilisable et modifiable dans Premiere Pro, permettant à l’équipe de mettre à jour les scores et visuels en toute autonomie, tout en conservant une identité visuelle cohérente et impactante.",

    videos: [
      {
        src: "/img/habillage/v1.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/habillage/v2.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "plate motion",
    image: "/img/plate/cover.png",
    tags: ["Motion"],
    description:
      "Exploration personnelle en motion design 3D, branding fictif autour de la vaisselle. Réalisé sur Blender, Plate Motion est un projet expérimental mêlant animation 3D et mise en scène graphique. J’y mets en mouvement un ensemble d’assiettes stylisées qui s’assemblent de manière fluide, comme une chorégraphie visuelle. Cette animation explore les possibilités de branding autour d’une marque fictive liée à l’art de la table.",

    videos: [
      {
        src: "/img/plate/plate.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "parfum thepage",
    image: "/img/labs/cover.png",
    tags: ["Motion"],
    description:
      "Exploration personnelle en motion design 3D, univers fictif autour d’un produit parfum/crème. Ce projet personnel met en scène une animation 3D poétique autour d’un produit cosmétique fictif. Inspiré par les codes du parfum et de la beauté, j’ai imaginé une chorégraphie fluide où le flacon s’élève, s’assemble, entouré de pétales en suspension. Une expérimentation artistique mêlant élégance, mise en scène produit et esthétisme sensoriel.",

    videos: [
      {
        src: "/img/labs/parfum.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },
  {
    title: "Other World",
    image: "/img/otherWorld/cover.png",
    tags: ["Motion"],
    description:
      "Exploration personnelle en motion design 3D, mise en scène de personnages stylisés. Other World est un projet expérimental mêlant narration visuelle et esthétique onirique. J’y ai animé des personnages en robes évoluant dans un univers 3D texturé, avec des simulations de tissus réalistes réalisées sous Marvelous Designer. Le projet a été développé sur Cinema 4D et Blender, dans une démarche de recherche artistique autour du mouvement, de l’atmosphère ",

    videos: [
      {
        src: "/img/otherWorld/face.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/otherWorld/other.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/otherWorld/seq.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },

  {
    title: "VR Venus",
    image: "/img/venus/banner3dart.png",
    tags: ["web VR"],
    description:
      "Exploration personnelle en réalité augmentée, tracking 3D sur image imprimée. VR Venus est une expérimentation autour de l’AR, où un objet 3D est rendu en temps réel et tracké sur une image ou un QR code, que ce soit sur écran ou support imprimé. Ce projet mêle modélisation 3D et techniques de réalité augmentée pour créer une expérience visuelle interactive, à la frontière entre art digital et technologie immersive.",
    images: [
      "/img/venus/venus.png",
      "/img/venus/venus2.png",
      "/img/venus/milo-qrcode.png",
      "/img/venus/milo.png",
    ],

    link: "https://aurelien-lepage.com/saint/eglise.html",
  },

  {
    title: "Mostro",
    image: "/img/mostro/cover-mostro.png",
    tags: ["Motion", "Montage"],
    description:
      "Montage vidéo et motion design pour Mostro. À partir des rushs fournis, j’ai réalisé le montage complet d’une interview de présentation du projet : sélection des plans, rythmes, titrages et habillage graphique. J’ai également animé le logo et conçu des écrans motion pour illustrer l’interface de l’outil, afin de rendre la démonstration plus claire, dynamique et compréhensible pour le public.",

    videos: [
      {
        src: "/img/mostro/exportBento_mostro-light.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/mostro/MOSTRO-montage.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],
  },

  {
    title: "Syncit",
    image: "/img/syncit/cover-syncit.png",
    tags: ["Motion", "Montage"],
    description:
      "Montage vidéo et motion design pour Syncit, projet Web3 dans l’écosystème crypto. À partir des rushs fournis, j’ai réalisé le montage complet d’une vidéo de présentation du produit : sélection des plans, structuration du discours, rythmes et titrages. J’ai également créé un habillage motion pour mettre en valeur l’interface et les fonctionnalités clés de Syncit, afin de rendre la démo plus claire, dynamique et mémorable pour les futurs utilisateurs comme pour les investisseurs.",

    videos: [
      {
        src: "/img/syncit/bento-syncit.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/syncit/syncit-montage.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
    ],
  },

  {
    title: "Product Pulse",
    image: "/img/productShow/cover-show.png",
    tags: ["Motion", "Montage"],
    description:
      "Projet personnel en motion design, pensé comme un format court de 15 secondes pour présenter une interface produit de manière simple, claire et dynamique. Une exploration autour du rythme, de la composition et du motion “product first ",

    videos: [
      {
        src: "/img/productShow/poducttoshow.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      // {
      //   src: "/img/syncit/syncit-montage.mp4",
      //   type: "mp4",
      //   mimeType: "video/mp4",
      // },
    ],
  },

  {
    title: "UX Mouvement",
    image: "/img/uxMotion/cover-ux.png",
    tags: ["Motion", "Montage"],
    description:
      "Vidéo explicative en motion design pour vulgariser l’UX design et son importance au quotidien. À travers une série de scènes simples et dynamiques, la vidéo montre que nous faisons l’expérience de l’UX à chaque interaction, que ce soit derrière un écran ou lors d’un rendez-vous. L’objectif : montrer comment l’UX design met l’utilisateur à l’aise, le guide et instaure un climat de confiance en rendant les parcours plus clairs et plus fluides.",

    videos: [
      {
        src: "/img/uxMotion/masterclean.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      // {
      //   src: "/img/syncit/syncit-montage.mp4",
      //   type: "mp4",
      //   mimeType: "video/mp4",
      // },
    ],
    images: ["/img/uxMotion/sceneopen.gif", "/img/uxMotion/3Dref.gif"],
  },

  {
    title: "Repliq - Product Explainer Video",
    image: "/img/repliq/cover-repliq.png",
    tags: ["Motion", "Montage"],
    description:
      "Vidéo produit réalisée pour Repliq, une application Web3 qui permet de créer, suivre et partager des portefeuilles crypto. J’ai assuré le montage, le motion design et la direction narrative afin de présenter l’application de manière claire, rythmée et accessible. La vidéo combine scènes filmées, storytelling et démonstration produit : introduction scénarisée, walkthrough des fonctionnalités clés (création de portefeuille, browsing, creator view, notifications, filtres, fees), puis outro dans un ton “builder” inspiré des codes Web3.",

    videos: [
      {
        src: "/img/repliq/bento-repliq.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      {
        src: "/img/repliq/render-repliq.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },
      // {
      //   src: "/img/syncit/syncit-montage.mp4",
      //   type: "mp4",
      //   mimeType: "video/mp4",
      // },
    ],
  },
  {
    title: "Event Teaser",
    image: "/img/jade/cover-jade.png",
    tags: ["Motion", "Montage"],
    description:
      "Vidéo teaser réalisée pour annoncer la participation de ZeroHash à Stablecon. J’ai conçu un format court et rythmé de 30 secondes, dans les couleurs et codes visuels de la marque, afin de présenter l’arrivée de ZeroHash à l’événement et d’introduire le thème principal de la keynote : l’impact des stablecoins sur l’économie réelle. Le teaser met en avant : les partenaires présents, l’importance de l’événement, et la prise de parole du CEO de ZeroHash. La vidéo se conclut sur un call-to-action invitant la communauté à rejoindre Stablecon.",

    videos: [
      {
        src: "/img/jade/jade.mp4",
        type: "mp4",
        mimeType: "video/mp4",
      },

      // {
      //   src: "/img/syncit/syncit-montage.mp4",
      //   type: "mp4",
      //   mimeType: "video/mp4",
      // },
    ],
  },
];

export default projects;
